import useGetTenants from 'core/features/tenants/hooks/useGetTenants'
import { useState } from 'react'
import SelectBaseAntd, { SelectBaseAntdProps } from '../SelectBaseAntd'

export interface SelectTenantProps<T = any> extends SelectBaseAntdProps<T> {}

function SelectTenant({ ...rest }: SelectTenantProps) {
  const [search, setSearch] = useState<string>()

  const { isLoading, data } = useGetTenants({
    page: 1,
    limit: 1000
  })

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione..."
      searchValue={search}
      showSearch
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.items?.map(item => ({
        value: item.id,
        label: item.nome
      }))}
      {...rest}
    />
  )
}

export default SelectTenant
